var Accounts = function() {

	var comp = $('[data-component="accounts"]');

	this.init = function() {

		activeAccount();

	}

	function activeAccount(){
		comp.find('.account').on('mouseenter', function(){
			$(this).addClass('focus');
		})
		comp.find('.account').on('mouseleave', function(){
			$('.account').removeClass('focus');
		})
		$("#login-type").mCustomScrollbar();
	}

	return this.init();

}
